import { Box, styled } from '@withjoy/joykit';

export const ShopFeatureBox = styled(Box)`
  max-width: 100%;
  width: 920px;
  margin: 0 auto;
`;
